import {AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn} from '@angular/forms';

export class CustomValidator {
  // Number only validation
  static numeric(control: AbstractControl) {
    return CustomValidator.genericNumeric(control, /^[0-9]+$/);
  }

  static numericPositiveAndNegativeNotRequired(control: AbstractControl) {
    const val = control.value;
    if (val == '' || val == null) return null;
    return CustomValidator.genericNumeric(control, /^-?[0-9]+$/);
  }

  static decimalNotRequired(control: AbstractControl) {
    const val = control.value;
    if (val == '' || val == null) return null;
    return CustomValidator.genericNumeric(control, /^-?[0-9]+(,[0-9]+)?$/);
  }

  private static genericNumeric(control: AbstractControl, regex){
    const val = control.value;

    if (val === null || val === '') { return { 'invalidNumber': true }; }

    if (!val.toString().match(regex)) { return { 'invalidNumber': true }; }

    return null;
  }

  static numericButNotRequired(control: AbstractControl) {
    const val = control.value;
    if (val !== null && val !== '' && !val.toString().match(/^[0-9]+$/)) { return { invalidFilledNumber: true }; }
    return null;
  }

  static singleDropdown(input: FormControl) {
    return input.value === '' || input.value === 0 || input.value === null ? { emptyDropDown: true } : null;
  }

  static minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map(control => control.value)
        .reduce((prev, next) => next ? prev + next : prev, 0);
      return totalSelected >= min ? null : {required: true};
    };
    return validator;
  }

  static reservedWords(control: AbstractControl){
    let notAllowedList = [
      //Argumentos reservados pelo nosso sistema
      "InstanceId", "NextState", "StateLifeCycle", "NextStateScheduledDateTime"
      //Tipos de variáveis
      , "Boolean", "Byte", "Char", "DateTime", "Decimal", "Double"
      , "Int16", "Int32", "Int64", "UInt16", "UInt32", "UInt64","Float",
      "SByte", "Single",
      //Palavras reservadas no visual basic
      "AddHandler", "AddressOf", "Alias", "And", "AndAlso", "As", "ByRef", "ByVal", "Call", "Case",
      "Catch", "CBool", "CByte", "CChar", "CDate", "CDec", "CDbl", "CInt", "Class", "CLng",
      "CObj", "Const", "Continue", "CSByte", "CShort", "CSng", "CStr", "CType", "CUInt", "CULng",
      "CUShort", "Date", "Declare", "Default", "Delegate", "Dim", "DirectCast", "Do", "Each", "Else",
      "ElseIf", "End", "EndIf", "Enum", "Erase", "Error", "Event", "Exit", "FALSE", "Finally",
      "For", "Friend", "Function", "Get", "GetType", "Global", "GoSub", "GoTo", "Handles", "If",
      "Implements", "Imports", "In", "Inherits", "Integer", "Interface", "Is", "IsNot", "Let", "Lib",
      "Like", "Long", "Loop", "Me", "Mod", "Module", "MustInherit", "MustOverride", "MyBase", "MyClass",
      "Namespace", "Narrowing", "New", "Next", "Not", "Nothing", "NotInheritable", "NotOverridable", "Object", "Of",
      "On", "Operator", "Option", "Optional", "Or", "OrElse", "Overloads", "Overridable", "Overrides", "ParamArray",
      "Partial", "Private", "Property", "Protected", "Public", "RaiseEvent", "ReadOnly", "ReDim", "REM", "RemoveHandler",
      "Resume", "Return", "Select", "Set", "Shadows", "Shared", "Short", "Static", "Step", "Stop",
      "String", "Structure", "Sub", "SyncLock", "Then", "Throw", "To", "TRUE", "Try", "TryCast",
      "TypeOf", "Variant", "Wend", "UInteger", "ULong", "UShort", "Using", "When", "While", "Widening",
      "With", "WithEvents", "WriteOnly", "Xor",
      //Palavras não reservadas mas inadequadas
      "Ansi", "Assembly", "Auto", "Binary", "Compare", "Custom", "Explicit", "IsFalse", "IsTrue", "Mid",
      "Off", "Preserve", "Strict", "Text", "Unicode", "Until"
    ];
    const val = control.value;
    let contains = notAllowedList.filter(i => i.toLowerCase() === val.toLowerCase()).length > 0;
    if (contains){
      return { 'reservedWord': true };
    }
    return null;
  }

  static validateDatetime(initialDate: string, finalDate: string) {
    // validar se a data/hora informada é valida
    return (formGroup: FormGroup) => {
      const iniDate = formGroup.controls[initialDate];
      const endDate = formGroup.controls[finalDate];

      if (!iniDate || !endDate) {
        return null;
      }

      // essa validação não determina obrigatoriedade de preenchimento dos campos
      if (iniDate.value == null || endDate.value == null || iniDate.value === '' || endDate.value === '') {
        return null;
      }

      const dtIni = new Date(iniDate.value).toISOString();
      const dtEnd = new Date(endDate.value).toISOString();

      if (endDate.errors && !endDate.errors.invalidDateTime) {
        return null;
      }

      if (dtEnd < dtIni) {
        endDate.setErrors({ invalidDateTime: true });
      } else {
        endDate.setErrors(null);
      }
    };
  }

  static trimRequired(control: AbstractControl) {
    const val = control.value;
    if (val === null || val.trim() === '') { return { 'required': true }; }
    return null;
  }

  static onlyStringAndNumbersAccepted(control: AbstractControl) {
    const val = control.value;
    if (val !== null && val !== '' && !val.toString().match(/^([_a-zA-Z]|[_a-zA-Z\\d]|[0-9])+$/)) {
      return { invalidStringAndNumberAccepted: true};
    }
    return null;
  }

  static validatePassword(password: string, confirmPassword: string) {
    return (formGroup: FormGroup) => {
      const pwdControl = formGroup.controls[password];
      const confirmPwdControl = formGroup.controls[confirmPassword];
      if (!pwdControl || !confirmPwdControl) {
        return null;
      }

      if (confirmPwdControl.errors && !confirmPwdControl.errors.passwordMismatch) {
        return null;
      }

      if (pwdControl.value !== confirmPwdControl.value) {
        confirmPwdControl.setErrors({ passwordMismatch: true });
      } else {
        confirmPwdControl.setErrors(null);
      }
    };
  }

}
